import { useDispatch, useStore } from 'react-redux'
import { startNSLogout } from '../redux/slice/nsLoginSlice'
import { useEffect, useState } from 'react'
import { APPLICATION_MODE_NEW } from '../app/constants'

export default function Navigation(props) {
    const dispatch = useDispatch()
    let {applicationType, applicationMode = APPLICATION_MODE_NEW} = props.match.params
    if(!applicationType && props.applicationType) {
        applicationType = props.applicationType
    }
    const {userAuth} = useStore().getState()
    let loggedIn = false

    if(userAuth 
        && userAuth.userData) { 
        const username = userAuth.userData.username
        loggedIn = username !== undefined && username !== null && username.length > 0
    }

    const [isUserLoggedin, setIsUserLoggedin] = useState(loggedIn)

    useEffect(() => {
        if(userAuth 
            && userAuth.userData) { 
                const username = userAuth.userData.username 
                const loggedIn = username !== undefined && username !== null && username.length > 0
                setIsUserLoggedin(loggedIn)
        }
    },[userAuth, setIsUserLoggedin])

    const handleSignout = () => { 
        dispatch(startNSLogout(applicationType,applicationMode))
    }

    return (
        <nav id="navigation" className="ribbon" role="navigation" aria-label="Main Navigation">
            <div className="container">
                <div className="row">
                    <div className="col-xs-2">
                        <a href="https://novascotia.ca/" hrefLang="en">
                            <img className="ribbon-img" 
                                src="https://novascotia.ca/clf/ignition/img/nsvip-en-white-flag.svg" 
                                alt="Government of Nova Scotia" />
                        </a>
                    </div>
                    <div className="col-xs-8">
                        {/* <span style={ {float:"left", color:"#fff", margin: "15px 0 0 0"}}>
                            <span >
                                <b>{title}</b>
                            </span>
                        </span> */}
                    </div>
                    {isUserLoggedin && <div className="col-xs-2 signoutButtonContainer rightAlign">
                        <button id="signoutButton" className="signoutButton" onClick={handleSignout}>
                            <span className="signoutButton_text">Sign out</span>
                        </button>
                    </div>}
                </div>
            </div>
        </nav>
    )
}